import SEOHead from "@/components/feature/SEOHead";

export default function HomeSEO() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://17cyqc.com/#organization",
        name: "17c一起草国",
        url: "https://17cyqc.com",
        description: "17c一起草国是优质内容分享平台，致力于为读者提供有价值的阅读体验，涵盖热门推荐、深度解读、精品原创、教程指南等多个领域。",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "400-888-0000",
          contactType: "customer service",
          availableLanguage: "Chinese",
        },
        address: {
          "@type": "PostalAddress",
          addressLocality: "北京",
          addressRegion: "朝阳区",
          streetAddress: "建国路88号",
          addressCountry: "CN",
        },
      },
      {
        "@type": "WebSite",
        "@id": "https://17cyqc.com/#website",
        url: "https://17cyqc.com",
        name: "17c一起草国",
        inLanguage: "zh-CN",
        publisher: { "@id": "https://17cyqc.com/#organization" },
      },
      {
        "@type": "WebPage",
        "@id": "https://17cyqc.com/#webpage",
        url: "https://17cyqc.com",
        name: "17c一起草国 - 优质内容分享平台",
        isPartOf: { "@id": "https://17cyqc.com/#website" },
        about: { "@id": "https://17cyqc.com/#organization" },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "17c一起草国是什么样的平台？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "17c一起草国是一个优质内容分享平台，我们汇聚了各领域的精选文章和原创内容。无论你是想获取最新资讯、学习实用技能，还是寻找深度阅读体验，在这里都能找到适合你的内容。",
            },
          },
          {
            "@type": "Question",
            name: "如何找到我感兴趣的内容？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "你可以通过首页的分类导航快速进入感兴趣的领域。我们提供六大内容分类。",
            },
          },
          {
            "@type": "Question",
            name: "平台上的内容是否免费？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "是的，17c一起草国上的所有内容均免费开放阅读。我们致力于让优质内容触手可及。",
            },
          },
          {
            "@type": "Question",
            name: "我可以投稿自己的文章吗？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "当然可以！我们非常欢迎优秀创作者加入。你可以通过关于我们页面提供的联系方式投稿。",
            },
          },
          {
            "@type": "Question",
            name: "如何在手机上获得更好的阅读体验？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "17c一起草国采用响应式设计，在手机、平板和电脑上都能获得良好的阅读体验。",
            },
          },
        ],
      },
    ],
  };

  return (
    <SEOHead
      meta={{
        title: "17c一起草国 - 优质内容分享平台，免费观看完整版",
        description: "17c一起草国是优质内容分享平台，提供热门推荐、深度解读、精品原创、教程指南等内容，致力于为用户提供免费完整版阅读体验。涵盖最新资讯、学习方法、个人成长等多元化主题。",
        keywords: "17c一起草国, 内容分享, 免费阅读, 完整版, 文章平台, 优质内容",
        canonical: "https://17cyqc.com",
        ogTitle: "17c一起草国 - 优质内容分享平台，免费观看完整版",
        ogDescription: "17c一起草国是优质内容分享平台，提供热门推荐、深度解读、精品原创、教程指南等内容，致力于为用户提供免费完整版阅读体验。",
        ogUrl: "https://17cyqc.com",
        ogType: "website",
        jsonLd,
      }}
    />
  );
}